import { formatRecipesPerPackLine } from './packRecipeCount.js';
import './RecipePacks.css';

/**
 * BrowseThinPrompt — inline card shown in Browse view when the full recipe library is thin.
 * Displays 3 pack chips that open the pack detail when clicked.
 * Parent gates on unfiltered library size (not browse filter result counts).
 */
export default function BrowseThinPrompt({ packs, onOpenPack, isMobile = false }) {
  if (!packs || packs.length === 0) return null;

  if (isMobile) {
    return (
      <div className="rp-mobile-browse-prompt">
        <div className="rp-mobile-browse-prompt-headline">Library a bit thin? Add a pack.</div>
        <div className="rp-mobile-browse-prompt-sub">{formatRecipesPerPackLine(packs, '— built to share staples.')}</div>
        <div className="rp-mobile-browse-chips-scroll">
          {packs.slice(0, 4).map(p => (
            <button key={p.id} type="button" onClick={() => onOpenPack(p.id)} className="rp-mobile-pack-chip">
              <span className="rp-mobile-pack-chip-swatch">
                {p.swatches.slice(0, 4).map((s, i) => (
                  <span key={i} className="rp-browse-swatch-cell" style={{ '--rp-swatch-bg': s }} />
                ))}
              </span>
              <span>{p.name}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="rp-browse-thin-prompt">
      <div className="rp-browse-thin-text">
        <div className="rp-browse-thin-headline">Library a bit thin? Add a pack.</div>
        <div className="rp-browse-thin-sub">{formatRecipesPerPackLine(packs, '— built to share staples so the shop stays tight.')}</div>
      </div>
      <div className="rp-browse-thin-chips">
        {packs.slice(0, 3).map(p => (
          <button key={p.id} type="button" onClick={() => onOpenPack(p.id)} className="rp-pack-chip">
            <span className="rp-pack-chip-swatch">
              {p.swatches.slice(0, 4).map((s, i) => (
                <span key={i} className="rp-browse-swatch-cell" style={{ '--rp-swatch-bg': s }} />
              ))}
            </span>
            <span className="rp-browse-chip-name">{p.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
